var map = {
	"./Ezamazwe.PNG": 693,
	"./Me1.jpg": 101,
	"./Me2.jpg": 17,
	"./airbnb-clone.png": 753,
	"./diamondShot.PNG": 182,
	"./employee.png": 96,
	"./foodApp.png": 223,
	"./hotel.png": 341,
	"./limitless.png": 958,
	"./pepeChain.png": 804,
	"./shopping.png": 901,
	"./todolist.png": 377,
	"./untrainedChefs.jpeg": 409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;